import {Stack, Typography} from "@mui/joy";
import React, {useEffect} from "react";
import {useNotification} from "../hooks/useNotification";
import NotificationItemComponent from "../components/NotificationItemComponent";
import EmptyNotificationComponent from "../components/EmptyNotificationComponent";
import PaginationComponent from "../components/PaginationComponent";
import {useSearchParams} from "react-router-dom";
import LoadingPageComponent from "../components/Loading/LoadingPageComponent";
import {useTranslation} from "react-i18next";

const NotificationsPage = () => {
    const {t}=useTranslation()
    const [searchParams] = useSearchParams()
    const {notifications, markedAsRead, loading, loadNotifications} = useNotification()

    useEffect(() => {
        loadNotifications(parseInt(searchParams.get("page")))
    }, [searchParams])

    return <Stack gap={4} paddingY={3} paddingX={{md: 15, xs: 3}} height={"100dvh"}>
        <Stack gap={1}>
            <Typography level={"h1"}>
                {t("notificationsTitle")}
            </Typography>
            <Typography>
                {t("notificationsDescription")}
            </Typography>
        </Stack>

        {(!notifications?.data || notifications.data.length === 0) && !loading && <EmptyNotificationComponent/>}

        {loading ?
            <LoadingPageComponent label={"Notifications"}/> :
            <Stack justifyContent={"space-between"} height={"100%"}>
                <Stack gap={1.5} height={"max-content"}>
                    {notifications?.data?.map(value => <NotificationItemComponent notification={value}
                                                                                  markedAsRead={markedAsRead?.includes(value._id)}/>)}
                </Stack>

                <PaginationComponent pageCount={Math.ceil((notifications?.count || 0) / 15)}/>
            </Stack>}
    </Stack>

}

export default NotificationsPage